import { atom } from "jotai";

import type { Props } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import type { BannerAdUnit } from "scmp-app/components/advertisement/ad-slots/types";

export type AdSlotState = {
  desktop: HeaderAdSlotSpec | null;
  manualRefreshCount?: number;
  mobile: HeaderAdSlotSpec | null;
};

type HeaderAdSlotSpec = {
  adUnit: BannerAdUnit;
  autoRefreshOptions?: Props["autoRefreshOptions"];
  sizes?: googletag.GeneralSize;
  targeting?: Props["targeting"];
  zone?: Props["zone"];
};

export const defaultTopBannerAdSlotStateAtom: AdSlotState = {
  desktop: null,
  mobile: null,
};

export const topBannerAdSlotAtom = atom<AdSlotState>(defaultTopBannerAdSlotStateAtom);
